// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"_mc9gwauXwFR","text":"cWNUG0MKwQD4","modal":"_3P0hvfDiNIed"};